const isDevMode = process.env.NODE_ENV === 'development';

// Helper function to create error payload
function createErrorPayload(store, errorData) {
    return {
        user_id: store.state.user_info?.user_id || -1,
        instance: window.location.origin,
        page: window.location.href,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        ...errorData
    };
}

// Helper function to safely log errors to server
function logToServer(errorPayload) {
    try {
        U.ajax('log_any_errors', errorPayload, result=>{
            if (result.status != 'ok') {
                console.error('Error storing log', result)
                return
            }
        });
    } catch (logError) {
        console.error('Failed to log error to server:', logError);
    }
}

function vueErrorLogger(err, vm, info, store) {
    console.error('Vue Error:\n', err);

    // Mark immediately to prevent double-handling
    if (err) {
        err._vueHandled = true;
    }

    // If in development mode, return instead of sending to server
    if (isDevMode) {
        return;
    }

    const errorPayload = createErrorPayload(store, {
        error: {
            message: err?.message || 'Unknown Vue error',
            stack: err?.stack || null,
            info,
            component: vm?.$options?.name || 'anonymous',
            propsData: vm?.$options?.propsData
        },
        error_type: 'vue_error_handler'
    });

    logToServer(errorPayload);
};

function windowErrorLogger(message, source, lineno, colno, error, store) {
    // Skip if Vue already handled this error
    if (error?._vueHandled) {
        return;
    }

    console.error('Global Error:\n', error || message);

    // If in development mode, return instead of sending to server
    if (isDevMode) {
        return;
    }

    const errorPayload = createErrorPayload(store, {
        error: {
            message: error?.message || message || 'Unknown global error',
            stack: error?.stack || null,
            source,
            lineno,
            colno
        },
        error_type: 'window_onerror'
    });

    logToServer(errorPayload);
};

// Also handle unhandled promise rejections
function unhandledPromiseRejectionHandler(event, store) {
    // We do not need to log this error as the default handler will catch it, and
    // there is no way to prevent the browser from logging it.

    // If in development mode, return instead of sending to server
    if (isDevMode) {
        return;
    }

    const error = event.reason;
    const errorPayload = createErrorPayload(store, {
        error: {
            message: error?.message || 'Unhandled Promise Rejection',
            stack: error?.stack || null,
            reason: typeof error === 'string' ? error : JSON.stringify(error)
        },
        error_type: 'unhandled_promise_rejection'
    });

    logToServer(errorPayload);
};

export function initializeErrorLogging(vueInstance, store) {
    try {
        // Vue error handler
        vueInstance.config.errorHandler = (err, vm, info) => vueErrorLogger(err, vm, info, store);
    
        // Global window error handler
        window.onerror = (message, source, lineno, colno, error) => windowErrorLogger(message, source, lineno, colno, error, store);
    
        // Unhandled promise rejections
        window.addEventListener('unhandledrejection', event => unhandledPromiseRejectionHandler(event, store));
    
        console.log(`Error logging initialized ${isDevMode ? '(development mode)' : '(production mode)'}`);
    } catch (initError) {
        console.error('Failed to initialize error logging:', initError);
        return;
    }
}